<template>
    <div v-infinite-scroll="loadMore" infinite-scroll-distance="25">
        <slot :listPortion="listPortion" />
    </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'

const defaultScrollLimit = 15

const getScrollTarget = element => {
    let node = element
    while (
        node?.nodeType === 1 &&
        node.tagName !== 'HTML' &&
        node.tagName !== 'BODY'
    ) {
        const { overflowY } = window.getComputedStyle(node)
        if (overflowY === 'auto' || overflowY === 'scroll') {
            return node
        }
        node = node.parentNode
    }
    return document.documentElement
}

export default {
    name: 'InfiniteScroller',
    directives: {
        infiniteScroll,
    },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        ignoreUpdates: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            scrollLimit: defaultScrollLimit,
            scrollStep: defaultScrollLimit,
        }
    },
    computed: {
        listPortion() {
            return this.list.slice(0, this.scrollLimit)
        },
    },
    watch: {
        list: {
            immediate: true,
            handler() {
                if (this.ignoreUpdates) {
                    return
                }
                this.scrollLimit = defaultScrollLimit
                this.$nextTick(this.loadUntilScrollable)
            },
        },
    },
    methods: {
        loadMore() {
            if (this.scrollLimit < this.list.length) {
                this.scrollLimit += this.scrollStep
            }
        },
        loadUntilScrollable() {
            const scrollTarget = getScrollTarget(this.$el)
            if (
                this.scrollLimit < this.list.length &&
                scrollTarget.scrollHeight <= scrollTarget.clientHeight
            ) {
                this.scrollLimit += this.scrollStep
                this.$nextTick(this.loadUntilScrollable)
            }
        },
    },
}
</script>
